var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3155",
    "data-name": "Rectangle 3155",
    width: 27,
    height: 27,
    transform: "translate(-1.809 -1.809)",
    fill: "#00b7cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11099",
    "data-name": "Group 11099",
    transform: "translate(1.809 1.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11098",
    "data-name": "Group 11098",
    transform: "translate(0 0.038)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28994",
    "data-name": "Path 28994",
    d: "M11.712,0A11.712,11.712,0,1,0,23.423,11.712,11.714,11.714,0,0,0,11.712,0m0,21.471a9.76,9.76,0,1,1,9.76-9.76,9.762,9.762,0,0,1-9.76,9.76",
    transform: "translate(0 -0.042)",
    fill: "#00b7cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28995",
    "data-name": "Path 28995",
    d: "M14.609,12.67,10.2,10.027v-5.3a.976.976,0,0,0-1.952,0v5.856a1.061,1.061,0,0,0,.472.839l4.88,2.928a.979.979,0,1,0,1.007-1.679",
    transform: "translate(2.486 1.088)",
    fill: "#00b7cc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.ae1bb3e951e6e65631d8d4a74084c03c.svg";
export { ForwardRef as ReactComponent };